import React from 'react';
import './Calc.css';

class Calc extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ratesBuy: {},
            ratesSale: {},
            select_result: '0',
            select_result_sale: 0,
            d_select_result: '0',
            d_select_result_sale: 0,
            statusInput: 'buy',
            currencyActive: 'UAH',
            'calc_in-main': 'calc_in-main',
            'calc_in-sub': 'calc_in-sub'
        }
        this.currencyList = [];
    }
    componentDidMount() {
        this.getRatesForCalc();
    }
    getRatesForCalc() {
        fetch('https://api.privatbank.ua/p24api/pubinfo?json&exchange&coursid=5')
            .then(data => {
                return data.json();
            }).then(data => {
                let reserve_buy = {};
                let reserve_sale = {};
                for (let i = 0; i < data.length; i++) {
                    reserve_buy[data[i].ccy] = data[i].buy
                    reserve_sale[data[i].ccy] = data[i].sale
                    this.currencyList.push(data[i].ccy)
                }
                this.setState({
                    ratesBuy: { reserve_buy },
                    ratesSale: { reserve_sale }
                })
            })
    }


    prevFormSubmit = (event) => {
            event.preventDefault();
            let findAllElem = event.target.elements,
                input = findAllElem['input_value'].value,
                select = findAllElem['type'].value,
                findOutWhatToDo = findAllElem['rdb'].value;
            console.log(findAllElem)

            let calc_buy = +(input * this.state.ratesBuy.reserve_buy[select]).toFixed(2);
            let calc_sale = +(input * this.state.ratesSale.reserve_sale[select]).toFixed(2);

            if (findOutWhatToDo === 'Купить') {
                this.setState({
                    select_result: calc_buy,
                    select_result_sale: calc_sale,
                    d_select_result: calc_buy,
                    d_select_result_sale: calc_sale

                })
            } else if (findOutWhatToDo === 'Продать') {
                this.setState({
                    select_result: calc_sale,
                    select_result_secondary: calc_buy,
                    d_select_result: calc_sale,
                    d_select_result_sale: calc_buy
                })
            }

            if (select === 'BTC') {
                this.setState({ currencyActive: "USD" })
            } else {
                this.setState({ currencyActive: "UAH" })
            }
    }
    changeColorOne = () => {
        this.setState({
            'calc_in-main': 'calc_in-main',
            'calc_in-sub': 'calc_in-sub',
            select_result: this.state.d_select_result,
            select_result_secondary: this.state.d_select_result_sale,
        })
    }
    changeColorTwo = () => {
        this.setState({
            'calc_in-main': 'calc_in-sub',
            'calc_in-sub': 'calc_in-main',
            select_result: this.state.d_select_result_sale,
            select_result_secondary: this.state.d_select_result
        })
    }

    render() {
        return (
            <div className="main_calc" >
                <div className="calc_title">
                    <h2>Калькулятор обмена </h2>
                </div>
                <div className="calc-wrap">
                    <div className="calc_body">
                        <div className="body_select">
                            <form onSubmit={this.prevFormSubmit}>
                                <div className="select_check">
                                    <div className="calc_header">
                                        <b>Я хочу:</b>
                                    </div>
                                    <div>
                                            <input  type="radio" name='rdb' value="Купить" id='1'  defaultChecked />
                                            <label onClick={this.changeColorOne} className={this.state['calc_in-main']} htmlFor="1">Продать</label>
                                        </div>
                                        <div >
                                            <input type="radio" name='rdb' value="Продать" id='2' />
                                            <label onClick={this.changeColorTwo} className={this.state['calc_in-sub']} htmlFor="2">Купить</label>
                                        </div>
                                </div>
                                <div className="select_input">
                                    <b>Сумма:</b>
                                    <input type="text" name='input_value' />
                                    <select name='type'>
                                        {this.currencyList.map(item => {
                                            return <option value={item} key={item}>{item}</option>
                                        })}
                                    </select>
                                    <button>Расчитать</button>
                                </div>
                            </form>
                            <div className="select_result">
                                <h3>Результат:</h3>
                                <p>{this.state.select_result} {this.state.currencyActive}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

export default Calc;